var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricebar"},[_c('nuxt-link',{staticClass:"logo",attrs:{"to":"/"}},[_vm._v(" Pedalsure. ")]),_vm._v(" "),_c('Price')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }